import {
  getFormData,
  resetFormErrors,
  showFormErrors
} from '../../utils/form';
import * as notification from '../../components/notifications';

const initPage = () => {
  const changePasswordForm = $("#change-password-form");
  if (!changePasswordForm.length) {
    return ;
  }

  changePasswordForm.submit(() => {
    changePassword();

    return false;
  });

};

const getChangePasswordData = () => {
  const form = $("#change-password-form");

  return getFormData(form);
};

const changePassword = async () => {
  const form = $("#change-password-form");
  const data = getChangePasswordData();

  $('.btn-submit', form).loading();

  try {
    let response;
    response = await axios.patch("/api/users/current/password", data);

    resetFormErrors(form);
    notification.success(response.data.message);

    // Restore the button's original content first so the spans are back in the DOM
    // before we attempt to find them by ID.
    $('.btn-submit', form).loading(false);

    $('#profile-password-update-section-label-flow-1', form).removeClass('d-none');
    $('#profile-password-update-section-label-flow-2', form).addClass('d-none');
    $('#profile-password-update-section-current-password-input', form).removeClass('d-none');
    $('#profile-password-update-section-btn-flow-1', form).removeClass('d-none');
    $('#profile-password-update-section-btn-flow-2', form).addClass('d-none');

    $('#modal-delete-account-flow-1').removeClass('d-none');
    $('#modal-delete-account-flow-2').addClass('d-none');

    form.trigger('reset');
  } catch (e) {
    console.log('error', e);

    $('.btn-submit', form).loading(false);

    showFormErrors(form, e.response);
  }
};

$(initPage);
